import { schema } from 'normalizr';

const FILE_SCHEMA = new schema.Entity('files', {}, { idAttribute: '@id' });

export default {
  File: FILE_SCHEMA,
};
